import { render, staticRenderFns } from "./CbsRelationIcon.vue?vue&type=template&id=7f2a86c4&"
import script from "./CbsRelationIcon.vue?vue&type=script&lang=js&"
export * from "./CbsRelationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports